import React, { Component } from 'react';
import { ListLayout } from '../containers/Layout';
import { isEmpty } from "lodash";
import Spin from '../../../../commonModules/interface/Spin';
import { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableRow, TableCell, TableHead, TableBody, Button, IconButton, Box } from '@material-ui/core';
import { DeleteRounded, AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import DeleteDialog from '../../../../commonModules/interface/DeleteDialog';
import { toast } from 'react-toastify';

class ListComRea extends Component{
    state = {
        filteredList: [],
        selectSearchDisplay: {}, 
        selectSearch: "",


        deletePopUp: false,
        toDelete:{
            id:""
        },
    }

    createReapproList = () => {
        const { COMMERCIAL_REAS, SHOPS, AGENTS, currentPage, rowsPerPage } = this.props
        const { selectSearch } = this.state;
        let list = selectSearch ? this.commercialFilter(selectSearch) : Object.values(COMMERCIAL_REAS)
        
        // return list.map( reappro => { 
        return [list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map(reappro => {

            const commercial = AGENTS && AGENTS[reappro.commercial_id]
            const shop = SHOPS[reappro.shop_id] || {}

            return (        
                <TableRow key={reappro.id} hover >
                    {/* <td>{reappro.id}</td> */}
                    <TableCell>{(new Date(reappro.date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>
                        <a href="#" onClick={ ()=> this.props.handleSingleShop(shop) }> {shop.name}</a>
                    </TableCell>
                    <TableCell>
                        {commercial && 
                            <a href="#" onClick={ ()=> this.props.handleSingleCom(commercial.id) }> 
                                {commercial.name}
                            </a>
                        }
                    </TableCell>
                    
                    <TableCell>
                        <IconButton 
                            color="secondary"
                            onClick={() => this.props.handleSingleComRea(reappro, shop, commercial)}
                        >
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                    <TableCell>
                        <IconButton 
                            onClick={
                                () => this.setState({
                                    toDelete: reappro,
                                    deletePopUp: true
                                })  
                            }>
                            <DeleteRounded color="error" />
                        </IconButton>
                    </TableCell>
                </TableRow>
            )

            
        }), list.length]
    }

    createCommercialList = () => {
        const { AGENTS, COMMERCIAL_REAS } = this.props
        let list = []
        let comID = []

        if( AGENTS ){
            Object.values(COMMERCIAL_REAS).forEach( item => {
                if( !comID.includes(item.commercial_id)) {
                    comID.push(item.commercial_id)
                }
            })
            comID.forEach( agentID => { 
                let agent = AGENTS[agentID] || {id: agentID, name: ""}
                let selected = false
                if(this.state.selectSearch === agent.id) {  // already selected   
                    selected = true 
                } 
                list.push (       
                    {value:agent.id, label:agent.name, disabled:selected} 
                )
            })
        }

        return list
    }

    commercialFilter = (selected) => {
        const { COMMERCIAL_REAS } = this.props
        
        let filteredCommercial = Object.values(COMMERCIAL_REAS).filter( 
            rea => rea.commercial_id === selected
        )

        return filteredCommercial
    }

    deleteCommercialRea = async () => {
        console.log('[INFO] delete');
            await this.props.deleteCommercialRea(this.state.toDelete)
                
            if(this.props.STATE.commercialReas.error){
                console.log("[ERROR] delete purchase", this.props.STATE.commercialReas.error); 
                toast.error( this.props.STATE.commercialReas.error)
            } else {
                toast.success("Reappro supprimé")
                this.setState({
                    deletePopUp:false,
                    toDelete:{id: ""},
                })
            }                             
    }
    handleChangeMdp = (e) => {
        const field = e.target.name
        const value = e.target.value
        this.setState({
            [field]: value
        })
    }
    render(){
        const commercials = this.createCommercialList()
        let list = [[], 0]
        if(!isEmpty(this.props.COMMERCIAL_REAS)) {
           list = this.createReapproList()
        }

        // console.log("STATE", this.state);
        return (
            <React.Fragment>
                <div>
                    <Box p={1}> 
                    {/* ???  error when deleteDialog is open */}
                        <InputSelectMagasin
                            options={commercials}
                            value={this.state.selectSearchDisplay || {value:"", label:""}}
                            label="Sélectionner un Commercial"
                            onChange={ option => 
                                this.setState({ 
                                    selectSearch: option.value,
                                    selectSearchDisplay: option
                                })
                            }
                        /> 
                    </Box>
                    {this.state.deletePopUp &&
                        <DeleteDialog 
                            title={"le reappro n°" + this.state.toDelete.id}
                            handleSubmit={this.deleteCommercialRea}
                            close={()=>this.setState({ deletePopUp:false })}
                            open={true}
                            disabled={this.props.STATE.commercialReas.fetching}
                        />
                    }
                    
                    <ListLayout>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell component="th">ID</TableCell> */}
                                <TableCell component="th">Date</TableCell>
                                <TableCell component="th">Shop</TableCell>
                                <TableCell component="th">Commercial</TableCell>
                                {/* <TableCell component="th">Statut</TableCell> */}
                                <TableCell component="th" colSpan={2}>Détails</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list[0]}
                            {/* { isEmpty(this.props.COMMERCIAL_REAS) && this.props.STATE.commercialReas.fetching &&
                                <Spin noOverlay />
                            } */}
                            { this.props.STATE.commercialReas.fetching &&
                                <Spin noOverlay/>
                            }
                            { isEmpty(this.props.COMMERCIAL_REAS) && this.props.STATE.commercialReas.fetched &&
                            <TableRow>
                                <TableCell colSpan="7">
                                    <div className="text-center">
                                        <h5>Pas de Reapprovisionnement</h5> 
                                        Cliquez sur <b className="onglet">"Nouveau"</b> Pour en créer un
                                    </div>
                                </TableCell>
                            </TableRow>
                            }
                        </TableBody>
                        { list[1] > 20 && 
                            <TableFooterPagination
                                colSpan={4}
                                items={list[0]}
                                count={list[1]}
                                onChangePage={this.props.onChangePage}
                                initialPage={this.props.currentPage || 0}
                            />
                        }
                    </ListLayout>                                             
                </div>
            </React.Fragment>
        )
    }
}



export default ListComRea